import * as React from 'react'
import * as R from 'ramda'
import {url} from '../../App/AuthenticatedRoute'
import {
    OrderExportOverviewState,
    OrderExportRow
} from './OrderExportOverviewState'
import {OrderExportOverviewAction} from './OrderExportOverviewActions'
import AppBar from 'material-ui/AppBar'
import {MenuAndUpButton} from '../../View/MenuAndUpButton'
import List from 'material-ui/List/List'
import Divider from 'material-ui/Divider'
import ListItem from 'material-ui/List/ListItem'
import ActionOpenInNew from 'material-ui/svg-icons/action/open-in-new'
import IconButton from 'material-ui/IconButton'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import {downloadIcon} from '../../View/DownloadIcon'
import injectSheet from 'react-jss'
import {layers} from '../../Style'

const styles = {
    navigationBar: {
        height: '128px'
    },
    actionButton: {
        position: 'absolute',
        right: '44px',
        top: '100px',
        zIndex: layers.front
    },
    root: {
        padding: '50px 48px'
    }
}

interface Props {
    readonly state: OrderExportOverviewState
    readonly dispatch: (action: OrderExportOverviewAction) => void
}

export const OrderExportOverviewView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => {
            return (
                <div>
                    <div className="navigation">
                        <AppBar
                            title="Auftragsexporte"
                            className={classes.navigationBar}
                            iconElementLeft={
                                <MenuAndUpButton
                                    onMenuButtonClicked={
                                        () => dispatch({type: 'MenuButtonClicked'})}
                                    upUrl={url({type: 'OrderOverview'})}
                                />
                            }
                        />
                    </div>
                    <FloatingActionButton
                        className={classes.actionButton}
                        href={url({type: 'OrderExportCreate'})}
                    >
                        <ContentAdd/>
                    </FloatingActionButton>
                    <OrderExportList
                        orderExportRows={state.orderExportRows}
                        dispatch={dispatch}
                    />
                </div>)
        })

interface OrderExportProps {
    orderExportRows: OrderExportRow[],
    dispatch: (action: OrderExportOverviewAction) => void,
}

export const OrderExportList =
    injectSheet<OrderExportProps>(styles)(
        ({classes, orderExportRows, dispatch}) => {
            return (
                <div className={classes.root}>
                    <h2>Exporte</h2>
                    <List>
                        {R.intersperse(
                            <Divider/>,
                            R.map(
                                orderExportRow => {
                                    const {orderExport} = orderExportRow
                                    return (

                                        <ListItem
                                            key={orderExport.id}
                                            primaryText={orderExport.created.toString()}
                                            leftIcon={downloadIcon(orderExportRow.download)}
                                            rightIconButton={
                                                <IconButton
                                                    href={
                                                        url({
                                                            type: 'OrderExportCreateFromTemplate',
                                                            id: orderExport.id,
                                                        })
                                                    }
                                                    onClick={
                                                        event => event.stopPropagation()
                                                    }
                                                >
                                                    <ActionOpenInNew/>
                                                </IconButton>
                                            }
                                            onTouchTap={
                                                () => dispatch({
                                                    type: 'DownloadOrderExport',
                                                    id: orderExport.id,
                                                })
                                            }
                                        />

                                    )
                                },
                                orderExportRows,
                            ),
                        )}
                    </List>
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderExportOverview/OrderExportOverviewView.tsx